var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "about-children" }, [
    _c(
      "div",
      { class: ["about-children__wrapper", _vm.customBackground] },
      [
        !_vm.isReused
          ? [
              _c("BaseTitle", {
                staticClass: "about-children__title",
                attrs: { text: _vm.titleText }
              }),
              _c(
                "div",
                { staticClass: "about-children__container" },
                [
                  _c("BaseText", {
                    staticClass: "about-children__descr",
                    attrs: { text: _vm.text1 }
                  }),
                  _c("BaseText", {
                    staticClass: "about-children__descr",
                    attrs: { text: _vm.text2 }
                  })
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5f40148", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f40148","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutChildrenBlock.vue
// module id = lYem
// module chunks = 2